// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface CalculateFloorLevelInput
 */
export interface CalculateFloorLevelInput {
  /**
   *
   */
  elevation: RanaFile;
  /**
   *
   */
  percentile?: number;
  /**
   *
   */
  distanceMeters?: number;
  /**
   *
   */
  buildingsVector: RanaFile;
  /**
   *
   */
  buildingsVectorLayerName?: any | null;
}

/**
 * Check if a given object implements the CalculateFloorLevelInput interface.
 */
export function instanceOfCalculateFloorLevelInput(
  value: object
): value is CalculateFloorLevelInput {
  if (!("elevation" in value) || value["elevation"] === undefined) return false;
  if (
    (!("buildingsVector" in (value as Record<string, any>)) &&
      !("buildings_vector" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["buildingsVector"] === undefined &&
      (value as Record<string, any>)["buildings_vector"] === undefined)
  )
    return false;
  return true;
}

export function CalculateFloorLevelInputFromJSON(json: any): CalculateFloorLevelInput {
  return CalculateFloorLevelInputFromJSONTyped(json, false);
}

export function CalculateFloorLevelInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CalculateFloorLevelInput {
  if (json == null) {
    return json;
  }
  return {
    elevation: RanaFileFromJSON(json["elevation"]),
    percentile: json["percentile"] == null ? undefined : json["percentile"],
    distanceMeters: json["distance_meters"] == null ? undefined : json["distance_meters"],
    buildingsVector: RanaFileFromJSON(json["buildings_vector"]),
    buildingsVectorLayerName:
      json["buildings_vector_layer_name"] === undefined
        ? undefined
        : json["buildings_vector_layer_name"] === null
        ? null
        : json["buildings_vector_layer_name"],
  };
}

export function CalculateFloorLevelInputToJSON(json: any): CalculateFloorLevelInput {
  return CalculateFloorLevelInputToJSONTyped(json, false);
}

export function CalculateFloorLevelInputToJSONTyped(
  value?: CalculateFloorLevelInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    elevation: RanaFileToJSON(value["elevation"]),
    percentile: value["percentile"],
    distance_meters: value["distanceMeters"],
    buildings_vector: RanaFileToJSON(value["buildingsVector"]),
    buildings_vector_layer_name: value["buildingsVectorLayerName"],
  };
}
